import { ChangeEvent, FC } from 'react';
import { CircleIntegrations } from 'src/api/circles';
import MaterialTextField from 'src/components/material/textField';
import styles from './BrandingSection.module.scss';

interface Review360SectionProps {
  specialCode?: string;
  value: CircleIntegrations | null;
  /** The text as typed; the parent validates it on save. */
  draftEmail: string;
  error?: string;
  onChange: (draftEmail: string) => void;
}

/** Simple shape check; the API validates the address properly. */
export const isPlausibleEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

/**
 * Edit Circle: connects an OTH circle to its 360review team account. Shown
 * under the Branding section for circles with special code OTH only, like the
 * one-click Ordtilhandling look. Empty = the circle has no "360" tab.
 */
export const Review360Section: FC<Review360SectionProps> = ({
  specialCode,
  draftEmail,
  error,
  onChange,
}) => {
  if (specialCode?.trim().toUpperCase() !== 'OTH') {
    return null;
  }

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => onChange(event.target.value);

  return (
    <div className={styles.container}>
      <div className={styles.title}>360review (optional)</div>
      <div className={styles.description}>
        Connect this circle to your 360review team account. Members then get a
        &quot;360&quot; tab with their own 360, and Participants shows who has
        one. Leave empty to keep the tab off.
      </div>
      <div className={styles.field}>
        <div className={styles.fieldLabel}>360review admin email</div>
        <div className={styles.fieldHint}>
          The email the account owner logs in with at 360review.io/admin.
          Members are matched by the email they registered with.
        </div>
        <MaterialTextField
          variant="outlined"
          color="primary"
          type="email"
          placeholder="admin@example.com"
          value={draftEmail}
          maxLength={254}
          autoComplete="off"
          inputProps={{ 'aria-label': '360review admin email' }}
          onChange={handleChange}
        />
        {error && <div className={styles.fieldError}>{error}</div>}
      </div>
    </div>
  );
};
